import { render, staticRenderFns } from "./CancelReason.vue?vue&type=template&id=bca2b392&scoped=true&"
import script from "./CancelReason.vue?vue&type=script&lang=js&"
export * from "./CancelReason.vue?vue&type=script&lang=js&"
import style0 from "./CancelReason.vue?vue&type=style&index=0&id=bca2b392&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca2b392",
  null
  
)

export default component.exports